<template>
  <vz-dialog
    name="manager-help"
    title="Помощь менеджера"
    big
    @showed="onShown"
  >
    <vz-form ref="formRef" v-model="isValidForm" class="vz-manager-help-body">
      <div>
        Откуда<span class="color-primary">*</span>
        <city-autocomplete
          label=""
          v-model="form.fromCity"
        />
      </div>
      <div>
        Куда<span class="color-primary">*</span>
        <city-autocomplete
          label=""
          v-model="form.toCity"
        />
      </div>

      <div>
        <div>
          ФИО<span class="color-primary">*</span>
        </div>
        <vz-input v-model="form.fio" :rules="[formRules.required]" />
      </div>
      <vz-phone-input
        ref="phoneInput"
        v-model="form.phone"
        label="Телефон"
        :countries="phoneCountries"
        :rules="[formRules.required, formRules.phone]"
      />

      <div class="vz-manager-help-comment mt-10">
        <vz-textarea v-model="form.comment" label="Комментарий" rows="3" />
      </div>
    </vz-form>

    <template #footer>
      <div class="vz-align-center">
        <vz-button
          variant="primary"
          :disabled="!isValidForm"
          @click="onSendForm"
        >
          Запросить
        </vz-button>
      </div>
    </template>
    <vz-loader :status-loader="loader" />
  </vz-dialog>
</template>

<script setup lang="ts">
import {phoneCountries} from '~/common/objects';
import {storeToRefs} from 'pinia';
import {useOrderStore} from '~/stores/order';
import formRules from '~/common/vz-form-rules';
import FastOrderForm from '~/common/home/FastOrderForm';
import {defineExpose} from '@vue/runtime-core';
import {sendFeedbackVip} from '@/api/home';
import CityAutocomplete from '~/components/autocomplete/city-autocomplete.vue';

const { $showDialog, $hideDialog, $showToast } = useNuxtApp()
const {orderForm} = storeToRefs(useOrderStore())

const formRef = ref()

const isValidForm = ref(false)
const loader = ref(false)
const form = ref({
  fromCity: '',
  toCity: '',
  fio: '',
  phone: '',
  comment: '',
  vip: false
})

async function onSendForm() {
  const valid = await formRef.value.validate(false)
  if (!valid) {
    return
  }

  const sendForm = new FastOrderForm({
    fromCity: form.value.fromCity,
    toCity: form.value.toCity,
    fio: form.value.fio,
    phone: form.value.phone,
    comment: form.value.comment,
    vip: form.value.vip
  })

  loader.value = true
  const res = await sendFeedbackVip({...sendForm})
  loader.value = false

  if (res?.error?.id || !res?.message) {
    $showToast({
      variant: 'error',
      title: 'Ошибка',
      text: res.error?.msg || res?.message
    })
    return
  }
  $showToast({
    variant: 'success',
    title: 'Запрос отправлен',
    text: res?.message
  })
  cleanData()
  setTimeout(hide, 1000)
}

function onShown() {
  form.value.fromCity = orderForm.value.directions.dispatch.locationGuid
  form.value.toCity = orderForm.value.directions.destination.locationGuid
}

function cleanData(): void {
  form.value = {
    fromCity: '',
    toCity: '',
    fio: '',
    phone: '',
    comment: '',
    vip: false
  } 
}

function show() {
  $showDialog({name: 'manager-help'})
}

function hide() {
  $hideDialog({name: 'manager-help'})
}

defineExpose({ show, hide })
</script>

<style lang="scss" scoped>
.vz-manager-help-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 5px;

  .vz-manager-help-comment {
    grid-column-start: 1;
    grid-column-end: 3;
  }

  @media screen and (max-width: $sm) {
    grid-template-columns: 1fr;

    .vz-manager-help-comment {
      grid-column-end: 2;
    }
  }
}
</style>
